import axios from "../../api/axiosInstance";

export const isCountWorkbookFile = (file) => /\.xlsx$/i.test(file.name) && file.size > 0 && file.size <= 10 * 1024 * 1024;

export async function uploadCountWorkbook(file, config, countId) {
  const form = new FormData();
  form.append("file", file);
  const path = countId ? `/api/purchasing/inventory-counts/${countId}/import` : "/api/purchasing/inventory-counts/import";
  const { data } = await axios.post(path, form, config);
  if (!data?.success || !Number.isInteger(data.imported_cells) || data.imported_cells < 0 ||
    (!countId && !(Number.isSafeInteger(data.inventory_count_id) && data.inventory_count_id > 0))) {
    throw new Error("Invalid workbook import response");
  }
  return data;
}
